var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", style: { "--transformX": _vm.transformX } },
    [
      _c("img", {
        staticClass: "banner",
        attrs: {
          src: require("@/assets/images/shop/banner.jpg"),
          alt: "长沙阳光采购分平台",
        },
      }),
      _c(
        "div",
        { staticClass: "def-w" },
        [
          _c(
            "ul",
            { staticClass: "tab-head flex-center" },
            _vm._l(_vm.unitTypeOption, function (ut, index) {
              return _c(
                "li",
                {
                  key: ut[_vm.code],
                  staticClass: "tab-item",
                  class: { active: _vm.unitType === ut[_vm.code] },
                  on: {
                    click: function ($event) {
                      return _vm.chooseTab(ut[_vm.code], index)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(ut[_vm.label]))]
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "shop-list-box" },
            _vm._l(_vm.list, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "shop-list-item flex-center mr-20 mb-20",
                  on: {
                    click: function ($event) {
                      return _vm.navDetail(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "shop-item-img" }, [
                    _c("img", {
                      attrs: {
                        src: item.logo,
                        title: item.name,
                        alt: item.name,
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "shop-item-info" }, [
                    _c("div", { staticClass: "shop-item-title text-cut" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("div", { staticClass: "shop-item-desc" }, [
                      _c("span", { staticClass: "fc99" }, [
                        _vm._v("招标采购（项）："),
                      ]),
                      _c("span", { staticClass: "color-theme-red" }, [
                        _vm._v(_vm._s(item.listingNumber || "/")),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _c("info-pagination", {
            attrs: {
              "single-page-hide": "",
              total: _vm.total,
              "current-page": _vm.curPage,
              "page-size": _vm.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.curPage = $event
              },
              "update:current-page": function ($event) {
                _vm.curPage = $event
              },
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }